<ng-container *ngIf="ready == false">
  <br />
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <convfact-ticket-form [active]="active" [ticket]="ticket" [accountsAndTaxes]="accountsAndTaxes" [edit]="edit"
    [bankAccounts]="bankAccounts" *ngIf="ticket" [errors]="errors" (onSave)="saveData($event)"></convfact-ticket-form>
</ng-container>